import React, { useState, useEffect } from "react";
import "./ProccedToCheckOut.css";
import NavbarCustom from "../../Components/NavbarCustom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { useNewUser } from "../../APIContext/NewUserContext";

export const ProccedToCheckOut = () => {
  const {
    fetchCartItemsNew,
    applyCouponNew,
    removeCuponGuest,
    proceedToCheckoutGuest,
    proceedToCheckoutUser,
  } = useNewUser();
  const [cartData, setCartData] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [guestForm, setGuestForm] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
    address: "",
  });

  const user = JSON.parse(localStorage.getItem("user"));

  const handleGuestChange = (e) => {
    const { name, value } = e.target;
    setGuestForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchCart = async () => {
    try {
      const res = await fetchCartItemsNew();
      setCartData(res);
      if (res.summary && res.summary.coupon) {
        setAppliedCoupon(res.summary.coupon);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, [refresh]);

  if (!cartData) return null;

  const { items = [], summary = {} } = cartData;

  const handleApplyCoupon = () => {
    if (!couponCode) return;

    const data = { code: couponCode };
    applyCouponNew(data).then(() => {
      setRefresh(!refresh);
    });
  };

  const handleRemoveCoupon = () => {
    removeCuponGuest().then(() => {
      setRefresh(!refresh);
    });
    setAppliedCoupon(null);
    setCouponCode("");
  };

  const handleBuyNow = () => {
    if (user) {
      // Logged-in user flow
      proceedToCheckoutUser().then((res) => {
        if (res.success) {
          window.location.href = res.data?.url;
        }
      });
    } else {
      // ✅ Guest checkout flow

      if (guestForm.password !== guestForm.confirm_password) {
        alert("Passwords do not match");
        return;
      }

      const payload = {
        parent: {
          email: guestForm.email,
          username: guestForm.username,
          password: guestForm.password,
          first_name: guestForm.first_name,
          last_name: guestForm.last_name,
          phone: guestForm.phone,
          address: guestForm.address,
        },
      };

      proceedToCheckoutGuest(payload).then((res) => {
        if (res.success) {
          window.location.href = res.data?.url;
        }
      });
    }
  };

  const finalTotal = cartData.summary?.total || 0;
  const discount = cartData.summary?.discount_amount || 0;
  const discount_percent = cartData.summary?.coupon?.discount_value;

  return (
    <>
      <NavbarCustom />

      <div className="checkout-container">
        <div className="checkout-header">
          <BackBtn />
          <h1 className="black-text-clip">Checkout</h1>
        </div>

        <div
          className="checkout-grid"
          style={
            user
              ? { gridTemplateColumns: "1fr" }
              : { gridTemplateColumns: "1.2fr 1fr" }
          }
        >
          {/* LEFT – USER DETAILS */}
          {!user && (
            <div className="checkout-form">
              <h2>Add Your Details</h2>

              <div className="form-row">
                <input
                  name="first_name"
                  placeholder="First Name"
                  value={guestForm.first_name}
                  onChange={handleGuestChange}
                />
                <input
                  name="last_name"
                  placeholder="Last Name"
                  value={guestForm.last_name}
                  onChange={handleGuestChange}
                />
              </div>

              <input
                name="username"
                placeholder="Username"
                value={guestForm.username}
                onChange={handleGuestChange}
              />

              <input
                name="phone"
                placeholder="Phone Number"
                value={guestForm.phone}
                onChange={handleGuestChange}
              />

              <input
                name="email"
                placeholder="Email Address"
                value={guestForm.email}
                onChange={handleGuestChange}
              />

              <input
                type="password"
                name="password"
                placeholder="Password"
                value={guestForm.password}
                onChange={handleGuestChange}
              />

              <input
                type="password"
                name="confirm_password"
                placeholder="Confirm Password"
                value={guestForm.confirm_password}
                onChange={handleGuestChange}
              />

              <input
                name="address"
                placeholder="Address"
                value={guestForm.address}
                onChange={handleGuestChange}
              />
            </div>
          )}

          {/* RIGHT – ORDER SUMMARY */}
          <div className="checkout-summary">
            <div className=" mobile-label-cart-hide order-summery-header">
              <h3 className="black-text-clip">PRODUCT</h3>
              <h3 className="black-text-clip text-right">TOTAL</h3>
            </div>

            {items.map((item) => (
              <div className="summary-item black-text-clip" key={item.id}>
                <div>
                  <strong className="black-text-clip">
                    {item.package_name}
                  </strong>
                  {item.child_details ? (
                    <>
                      <p className="black-text-clip">
                        Player: {item.child_details?.name}
                      </p>
                      <p className="black-text-clip">
                        Grade: {item.child_details?.grade}
                      </p>
                      <p className="black-text-clip">
                        Jersey Size: {item.child_details?.jersey_size}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>Player: Any</p>
                    </>
                  )}
                </div>
                <span className="black-text-clip text-right">
                  ${item.total_price}
                </span>
              </div>
            ))}

            {/* COUPON */}
            <div className="coupon-section">
              <h4 className="black-text-clip">Apply Coupon</h4>

              {!appliedCoupon ? (
                <div className="coupon-input">
                  <input
                    placeholder="Enter coupon"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <button onClick={handleApplyCoupon}>Apply</button>
                </div>
              ) : (
                <div className="coupon-applied">
                  <span>
                    <i className="ri-discount-percent-fill"></i> Applied Coupon
                    Code: <strong>{appliedCoupon.code}</strong>, Discount:
                    <strong>
                      {" "}
                      ${discount}
                      {}{" "}
                      {discount_percent != null ? `(${discount_percent}%)` : ""}
                    </strong>
                  </span>
                  <button onClick={handleRemoveCoupon}>Remove</button>
                </div>
              )}
            </div>

            <div className="summary-details">
              <span className="black-text-clip">Sub Total</span>
              <span className="black-text-clip text-right">
                ${Number(finalTotal) + Number(discount)}
              </span>
            </div>

            <div className="summary-details-2">
              <span className="black-text-clip">
                Discount{discount_percent != null ? "" : " amount"}
              </span>
              <span
                style={{ color: "green", width: "40%", textAlign: "right" }}
              >
                ${discount}
                {} {discount_percent != null ? `(${discount_percent}%)` : ""}
              </span>
            </div>

            <div className="summary-total">
              <span className="black-text-clip">Total</span>
              <span className="black-text-clip text-right">${finalTotal}</span>
            </div>
          </div>
        </div>

        <div className="p-submit-button-container" style={{ padding: 0 }}>
          <button
            type="button"
            className="p-submit-button"
            onClick={handleBuyNow}
          >
            Buy Now <i className="ri-shopping-cart-2-fill cart-icon"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default ProccedToCheckOut;
